module.exports = __webpack_public_path__ + "img/roll_back.461535f4.svg";